<template>
  <div class="list">
    <div style="display:flex;padding-left:20px;padding-top:10px">
      <el-button type="primary" @click="Back">返 回</el-button>
    </div>
    <div class="el-card__body">
      <div style="background-color:white;witdh:100%;height:620px">
        <el-table
          height="550"
          :data="grades"
          max-height="550">
          <el-table-column
            type="index"
            width="100"
            align="center"
            label="序号">
            <template slot-scope="scope">
              <span>{{ (page - 1) * size + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="考试人">
          </el-table-column>
          <el-table-column
            prop="time"
            label="考试时间">
          </el-table-column>
          <el-table-column
            prop="namess"
            label="考卷名">
          </el-table-column>
          <el-table-column
            prop="scores"
            label="总分">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button type="danger" @click="getExam(scope.row)">批改</el-button>
              <!-- <el-button type="danger" @click="paperlist2(scope.row)">批改</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div style="margin:0 auto;" class="center select">
          <el-pagination
            background
            layout="prev, pager, next, total, jumper"
            :total="total"
            :current-page="page"
            :page-size="size"
            @current-change="pagechange">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 考试情况 -->
    <div>
      <el-dialog
        title="考试情况"
        :visible.sync="dialog">
        <h3 v-show="resultList.one.length">判断题</h3>
        <div style="margin:5px" v-for="(item, index) in resultList.one" :key="'likef' + index">
          <div class="exam_topic">
            <div class="topic_name">{{ perfixTopic(item.topic, index) }} ({{ item.scores }}分)</div>
            <div style="display:flex">
              <div>学生答案:{{ trueOrFalse(item.study) }}</div>
              <div style="width: 2rem"></div>
              <div>正确答案:{{ change2(item.answer) }}</div>
              <div style="width: 2rem"></div>
              <div style="color: green" v-if="trueOrFalse(item.study) === item.answer"><i class="el-icon-check"></i>
              </div>
              <div style="color: red" v-if="trueOrFalse(item.study) !== item.answer"><i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </div>
        <h3 v-show="resultList.two.length">选择题</h3>
        <div style="margin:5px" v-for="(item, index) in resultList.two" :key="'like' + index">
          <div class="exam_topic">
            <div class="topic_name">{{ perfixTopic(item.topic, index) }}{{ item.option }} ({{ item.scores }}分)</div>
            <div style="display:flex">
              <div>学生答案:{{ item.study == -1 ? ' 未答题' : item.study }}</div>
              <div style="width: 2rem"></div>
              <div>正确答案:{{ item.answer }}</div>
              <div style="width: 2rem"></div>
              <div style="color: green" v-if="item.study === item.answer"><i class="el-icon-check"></i></div>
              <div style="color: red" v-if="item.study !== item.answer"><i class="el-icon-close"></i></div>
            </div>
          </div>
        </div>
        <h3 v-show="resultList.three.length">多选题</h3>
        <div style="margin:5px" v-for="(item, index) in resultList.three" :key="'lik' + index">
          <div class="exam_topic">
            <div class="topic_name">{{ perfixTopic(item.topic, index) }} {{ item.option }} ({{ item.scores }}分)</div>
            <div style="display:flex">
              <div>学生答案:{{ item.study == -1 ? ' 未答题' : item.study }}</div>
              <div style="width: 2rem"></div>
              <div>正确答案:{{ item.answer }}</div>
              <div style="width: 2rem"></div>
              <div style="color: green" v-if="Questions(item.study, item.answer)"><i class="el-icon-check"></i></div>
              <div style="color: red" v-if="!Questions(item.study, item.answer)"><i class="el-icon-close"></i></div>
            </div>
          </div>
        </div>
        <h2 v-if="resultList.for.length">简答题</h2>
        <div class="exam_topic" v-for="(item, $index) in resultList.for" :key="$index">
          <div class="exam_topic">
            <div class="topic_name">{{ perfixTopic(item.topic, $index) }}({{ item.scores }}分)</div>
            <div style="margin:5px">
              <div>学生答案: {{ item.study === -1 ? ' 未答题' : item.study }}</div>
              <div style="width: 2rem"></div>
              <div>评分:
                <el-input :step="0.5" @keyup.native="proving2($index)"
                          :oninput="'if(value>'+item.scores+'){value='+item.scores+'}'" min="0" :max="item.scores"
                          v-model="item.subjectiveTotal" style="width: 6rem">分数
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <el-button @click="updateGrades">批改完成</el-button>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      // 考试表信息
      exam: '',
      examName: '',
      // 答卷表信息
      grades: [],
      page: 1,
      size: 7,
      total: 0,
      dialog: false,
      // 考试题目
      testCard: '',
      one: [],
      two: [],
      three: [],
      examId: null,
      Sid: 0,
      for: [],
      allData: {
        one: [],
        two: [],
        three: [],
        for: []
      }, // 当前试卷
      examData: [], // 试卷答案
      testCard0: false,
      testCard1: false,
      testCard2: false,
      testCard3: false,
      testCard4: false,
      totals: 0,
      // 学生答案
      study: [],
      beforeGrades: {},
      // 倒计时
      hour: '',
      minute: '',
      second: '',
      promiseTimer: '',
      examOption: [],
      remainTime: '',
      scores: 0
    }
  },
  mounted () {
    this.getGrades()
  },
  computed: {
    resultList () { // 选择
      let result = []
      let solution = this.study // 当前试卷答案
      let testPaper = this.allData
      for (let i in testPaper) {
        for (let f in solution) {
          if (i === f) {
            for (let j in testPaper[i]) {
              if (solution[f][j] !== undefined) {
                testPaper[i][j].study = solution[f][j].option
              } else {
                testPaper[i][j].study = -1
              }
            }
          }
        }
      }
      for (let i in testPaper.one) {
        testPaper.one[i].answer = this.change2(testPaper.one[i].answer)
      }
      for (let i in testPaper.two) {
        testPaper.two[i].answer = this.change(testPaper.two[i].answer)
      }
      for (let i in testPaper.three) {
        testPaper.three[i].answer = testPaper.three[i].answer.toString()
        if (testPaper.three[i].study.length === 0) {
          testPaper.three[i].study = '未答题'
        }
        testPaper.three[i].study = testPaper.three[i].study.toString()
      }
      result = testPaper
      return result
    }
  },
  methods: {
    perfixTopic (topic, index) {
      let value = topic.trim()
      if (parseFloat(value.substring(0, 1)).toString() === 'NaN') {
        value = (index + 1) + '、' + value
      }
      return value
    },
    proving2 (e) {
      // this.testCard[2][e].subjectiveTotal 是input的值
      // 先把非数字的都替换掉，除了数字和.
      this.allData.for[e].subjectiveTotal = this.allData.for[e].subjectiveTotal.replace(/[^\d.]/g, '')
      // 必须保证第一个为数字而不是.
      this.allData.for[e].subjectiveTotal = this.allData.for[e].subjectiveTotal.replace(/^\./g, '')
      // 保证只有出现一个.而没有多个.
      this.allData.for[e].subjectiveTotal = this.allData.for[e].subjectiveTotal.replace(/\.{2,}/g, '')
      // 保证.只出现一次，而不能出现两次以上
      this.allData.for[e].subjectiveTotal = this.allData.for[e].subjectiveTotal.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      console.log(this.allData.for[e].subjectiveTotal)
      if (this.allData.for[e].subjectiveTotal.indexOf('.') > 0) {
        this.allData.for[e].subjectiveTotal = this.allData.for[e].subjectiveTotal.slice(0, this.allData.for[e].subjectiveTotal.indexOf('.') + 2)
      }
    },
    // 分页监听
    pagechange (data) {
      this.page = data
      this.getGrades()
    },
    getGrades () {
      let obj = {}
      let sendData = {}
      sendData.data = obj
      obj.page = this.page - 1
      obj.size = this.size
      sendData.fn = this.getGradesfn
      sendData.vm = this
      req.Post('exam/typeGetgrades', sendData)
    },
    getGradesfn (e) {
      if (e.err_code !== 0) {
        alert(e.err_msg)
        return
      }
      this.grades = e.examData.value // 批改数据
      this.total = e.examData.value2 // 总数
    },

    getExam (row) {
      let sendData = {}
      sendData.data = row.exam_id
      sendData.fn = this.getExamfn
      let list = JSON.parse(row.exam)
      this.examId = row.id
      this.beforeGrades = row
      this.totals = row.selectTotal + row.subjectiveTotal
      this.study = list
      sendData.vm = this
      req.Post('exam/idGetexam', sendData)
    },
    // 获取整张试卷  原先 随机抽取题目
    getExamfn (data) {
      let info = data.examData[0]
      let obj = info.title
      // let str = obj.replaceAll('\\', '')
      let value = JSON.parse(obj)
      this.allData.one = value.one
      this.allData.two = value.two
      this.allData.three = value.three
      // 初始化
      for (let i in value.for) {
        value.for[i].subjectiveTotal = ''
      }
      this.allData.for = value.for
      this.dialog = !this.dialog
    },
    wholePaper (e) {
      let sendData = {}
      this.totals = e.selectTotal + e.subjectiveTotal
      this.study = JSON.parse(e.exam)
      let msg = {}
      msg.id = e.exam_id
      sendData.data = msg
      sendData.fn = this.wholePaperFn
      sendData.vm = this
      req.Post('exam/wholePaper', sendData)
    },
    Questions (option, answer) {
      if (option === undefined || answer === undefined) {
        return
      }
      let start = true
      if (option.length !== answer.length) {
        return false
      }
      for (let i in answer) {
        let options = option.toString()
        if (options.lastIndexOf(answer[i]) === -1) {
          start = false
        }
      }
      return start
    },
    wholePaperFn (data) { // TODO
      // eslint-disable-next-line eqeqeq
      if (data.data.length == 0) {
        this.$message.warning('当前岗位无试题')
        return
      }
      let json = data.result
      this.scores = json.scores
      let time = json.time
      this.remainTime = time * 60
      this.hour = Math.floor((this.remainTime / 3600) % 24)
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.examName = json.namess
      this.examId = json.id
      let str = json.title.replaceAll('\\', '')
      str = str.replaceAll('nB', 'B')
      str = str.replaceAll('nA', 'A')
      str = str.replaceAll('nD', 'D')
      str = str.replaceAll('nC', 'C')
      let value = JSON.parse(str)
      this.one = value.one
      this.two = value.two
      this.three = value.three
      this.for = value.for
      for (let i in this.one) {
        this.one[i].options = this.one[i].option
        this.one[i].option = -1
      }
      for (let i in this.two) {
        this.two[i].options = this.two[i].option
        this.two[i].option = -1
      }
      for (let i in this.for) {
        this.for[i].options = this.for[i].option
        this.for[i].option = null
      }
      for (let i in this.three) {
        this.three[i].options = this.three[i].option
        this.three[i].option = []
      }
      this.dialog = !this.dialog
      // this.countDowm()
    },
    Back () {
      this.$router.go(-1)
    },
    // 把下标转换为英文
    change (e) {
      if (e === '0' || e === 0) {
        return 'A'
      }
      if (e === '1' || e === 1) {
        return 'B'
      }
      if (e === '2' || e === 2) {
        return 'C'
      }
      if (e === '3' || e === 3) {
        return 'D'
      }
      if (e === '4' || e === 4) {
        return 'E'
      }
      if (e === '5' || e === 5) {
        return 'F'
      }
      return e
    },
    change2 (e) {
      if (e === 0 || e === '0') {
        return '错'
      }
      if (e === 1 || e === '1') {
        return '对'
      }
      return e
    },
    updateGrades () {
      let sendData = {}
      let obj = {}
      let num = 0

      for (let i in this.allData.for) {
        if (!this.allData.for[i].hasOwnProperty('subjectiveTotal') || this.allData.for[i].subjectiveTotal === '' || this.allData.for[i].subjectiveTotal === null) {
          num = num + 1
        }
      }
      if (num > 0) {
        alert('还有' + num + '题未批改')
        return
      }
      this.$confirm('批改后不可更改, 是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 统计简答题分数
        obj.subjectiveTotal = this.getSubjective(this.allData.for)
        obj.id = this.examId
        obj.exam = this.beforeGrades.exam
        sendData.data = obj
        sendData.fn = this.updateGradesfn
        sendData.vm = this
        req.Post('exam/updateGrades', sendData)
      }).catch(() => {
      })
    },
    updateGradesfn (e) {
      if (e.err_code !== 0) {
        return
      }
      this.getGrades()
      this.$message.success('批改成功')
      this.dialog = !this.dialog
    },
    trueOrFalse (data) {
      if (data === -1) {
        return '未答题'
      }
      if (data === 1) {
        return '对'
      }
      return '错'
    },
    // 计算客观题分数 (简答题)
    getSubjective (e) {
      let subjectiveTotal = 0
      let num = 0
      for (let i in e) {
        // debugger
        if (!e[i].hasOwnProperty('subjectiveTotal')) {
          num = num + 1
        }
        if (num === 0) {
          subjectiveTotal = subjectiveTotal + parseFloat(e[i].subjectiveTotal)
          console.log(parseFloat(e[i].subjectiveTotal))
        }
      }
      return subjectiveTotal
    }
  }
}
</script>
<style>
.el-card__body {
  padding: 25px;
  padding-top: 0;
}

.amount:hover {
  color: #002c74;
}

.amount {
  height: 20px;
  width: 31%;
  font-size: 25px;
  margin: 15px;
  color: #00aaff;
}

.exam {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-pagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/correct.vue